/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Prompt/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Prompt({
  children,
  viewPath = "/DesignSystem/Questions/Prompt",
  marginBottom = 20,
  marginRight = 0,
  marginTop = 15,
  text
  
}) {
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral700}
 fontSize={18}
 fontWeight={300}
 lineHeight={1.2}
 marginBottom={marginBottom}
 marginRight={marginRight}
 marginTop={marginTop}
 text={text}
 wordBreak="keep-all"
/>
{children}
</React.Fragment>)
}